import { t } from 'i18next'
import { APITypes } from 'plyr-react'
import React from 'react'
import { pushDatalayer } from '../../../datalayer'
import { GetCookiebarContent } from '../../../drupal/rendering/cookiebar_utils.mod'
import { CookieSensitiveContentWrapper } from '../cookiebar.mod'
import { setCookie } from '../cookiebar.utils.mod'
import { Iframe } from '../iframe.mod'
import { PurePlyr } from './plyr.mod'

type MediaProps = { url: string; useCookiebar: boolean } & (
  | {
      kind: 'media'
      plyrRef?: React.MutableRefObject<APITypes>
    }
  | {
      kind: 'iframe'
    }
)

export const Media = (props: MediaProps) => {
  const innerRef = React.useRef<APITypes>(null)
  const plyrRef = (props.kind == 'media' && props.plyrRef) || innerRef

  React.useEffect(() => {
    const plyr = plyrRef.current?.plyr
    if (plyr?.on == null) return
    const onPlay = () => pushDatalayer({ event: 'event.refresco', category: 'Video', action: 'Start', label: window.location.pathname })
    const onPause = () => pushDatalayer({ event: 'event.refresco', category: 'Video', action: 'Pause', label: window.location.pathname })
    const onEnded = () => pushDatalayer({ event: 'event.refresco', category: 'Video', action: 'End', label: window.location.pathname })
    if (props.kind == 'media') {
      plyr.on('play', onPlay)
      plyr.on('pause', onPause)
      plyr.on('ended', onEnded)
    }
    return () => {
      if (props.kind == 'media') {
        plyr.off('play', onPlay)
        plyr.off('pause', onPause)
        plyr.off('ended', onEnded)
      }
    }
  }, [plyrRef])

  const plyr = <PurePlyr videoRef={plyrRef} source={props.url} />

  return props.useCookiebar ? (
    <CookieSensitiveContentWrapper
      // CookiePro groups: 4 is Targeting Cookies, 5 is Social Media Cookies
      groupId={props.kind == 'media' ? 5 : 4}
      placeholder={
        <div className="media__placeholder">
          <div className="media__inner">
            <p>{GetCookiebarContent(props.kind || 'media')}</p>
            <a
              className=""
              onClick={() => {
                setCookie('so_you_accepted_the_cookies?', 'yes_i_did', 100000)
                window.location.reload()
              }}
            >
              {t('CookiesPlaceholder:AcceptCookies')}
            </a>
          </div>
        </div>
      }
    >
      {props.kind == 'media' ? plyr : <Iframe url={props.url} onLoaded={() => {}}></Iframe>}
    </CookieSensitiveContentWrapper>
  ) : props.kind == 'media' ? (
    plyr
  ) : (
    <Iframe url={props.url} onLoaded={() => {}}></Iframe>
  )
}
